import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

export class ApiUrlInterceptor implements HttpInterceptor {

    constructor(private baseUrl: string) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let url = req.url;
        if (url.indexOf(environment.API_URL) < 0) {

            // Strip beginning '/' if present
            if (url.charAt(0) === '/') {
                url = url.slice(1);
            }

            // Strip beginning 'api/' if present
            if (url.substr(0, 4) === 'api/') {
                url = url.slice(4);
            }

            // Reassemble url
            url = `${this.baseUrl}/${url}`;

            // Clone request with new URL
            req = req.clone({url});
        }
        return next.handle(req);
    }
}
